import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export function changeLada({ iccid, msisdn, zone }: { iccid?: string; msisdn?: string; zone: number }) {
  const data = {
    ...(iccid ? { iccid } : {}),
    ...(msisdn ? { msisdn } : {}),
    zone,
  };
  return axios.post(`${API_URL}operation/cambio/lada`, data);
}

export async function getAll(
  filters: any
) {
  const response = await axios.get(
    `${API_URL}catalogos/lada-movement`, { params: filters }
  );
  const data = response.data.doc.data;
  return data;
}

export async function getAvailableZones() {
  const response = await axios.get(
    `${API_URL}catalogos/lada-movement/available-zones`
  );
  const data = response.data.doc.data;
  return data;
}

export async function validatePhone({
  msisdn,
  iccid,
}: {
  msisdn: string | null;
  iccid: string | null;
}) {
  const payload: any = {};

  if (msisdn && msisdn.trim() !== "") {
    payload.msisdn = msisdn;
  } else if (iccid && iccid.trim() !== "") {
    payload.iccid = iccid;
  }

  return axios.post(`${API_URL}catalogos/customer/validate-zone`, payload);
}
